/**
 * @override Header 2.0: L2 column-by-id stays links-only (default fragment).
 * L3 gallery is GetNavLinkGalleryById on hover — one Link, not the whole column.
 */

import gql from 'graphql-tag';

import {BaseImageFragment} from '@amblique/king-living/app/contentful/fragments/image/base-image.fragment';
import {FullNavigationColumnFragment} from '@amblique/king-living/app/contentful/fragments/navigation-column/full-navigation-column.fragment';

export {
  getBaseNavigationColumnById,
  getNavigationColumnById,
  getBaseNavigationColumns,
  getNavigationColumns,
  getFullNavigationColumns,
} from '@amblique/contentful/app/contentful/queries/navigation-column.queries';

export const getFullNavigationColumnById = gql`
  ${FullNavigationColumnFragment}

  query GetFullNavigationColumnById($id: String!, $locale: String!, $preview: Boolean) {
    navigationColumn(id: $id, locale: $locale, preview: $preview) {
      ...FullNavigationColumnFragment
    }
  }
`;

export const getNavLinkGalleryById = gql`
  ${BaseImageFragment}

  query GetNavLinkGalleryById($id: String!, $locale: String!, $preview: Boolean) {
    link(id: $id, locale: $locale, preview: $preview) {
      sys {
        id
      }
      menuImageGalleryCollection {
        items {
          __typename
          ... on Image {
            ...BaseImageFragment
          }
        }
      }
    }
  }
`;
